import { render, staticRenderFns } from "./ParkingDashboard.vue?vue&type=template&id=241f18c7&scoped=true"
import script from "./ParkingDashboard.vue?vue&type=script&lang=js"
export * from "./ParkingDashboard.vue?vue&type=script&lang=js"
import style0 from "./ParkingDashboard.vue?vue&type=style&index=0&id=241f18c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f18c7",
  null
  
)

export default component.exports